<template>
  <x-waterfall
    ref="list"
    :load="load"
    :manual="manual"
    :disabled="disabled"
    :no-complete-tips="noCompleteTips"
    :empty-props="emptyProps"
    @change="data => $emit('change', makeUniGoods(data))"
  >
    <template #default="{ data }">
      <slot :data="makeUniGoods(data)">
        <x-goods-list
          :data="data"
          :one="one"
          :has-serial-no="hasSerialNo"
          :track="track"
        >
          <slot v-if="$slots.first" slot="first" name="first" />
        </x-goods-list>
      </slot>
    </template>
    <slot slot="empty" name="empty" />
    <slot slot="extra" name="extra" />
  </x-waterfall>
</template>

<script>
  import Vue from 'vue'
  import { makeUniGoods } from '@/utils'

  export default Vue.extend({
    props: {
      load: {
        type: Function,
        required: true,
      },
      one: {
        type: Boolean,
        default: false,
      },
      hasSerialNo: {
        type: Boolean,
        default: false,
      },
      track: {
        type: Object,
        default: () => ({}),
      },
      manual: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      emptyProps: {
        type: Object,
        default: () => ({}),
      },
      noCompleteTips: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      makeUniGoods,
      reload(source = null, clean = false) {
        return this.$refs.list.reload(source, clean)
      },
    },
  })
</script>
